// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/content_text_edit.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../statics/content_text_edit_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../statics/content_text_copy.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../statics/content_text_copy_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../statics/content_text_like.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../statics/content_text_like_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../../statics/content_text_negative.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../../statics/content_text_negative_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../../statics/content_text_collect.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../../statics/content_text_collect_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../../../statics/content_text_regenerate.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../../../statics/content_text_regenerate_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../../../statics/content_text_like_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../../../statics/content_text_negative_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../../../statics/content_text_collect_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../../../statics/recommend_butn_icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../../../../statics/recommend_star.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../../../../statics/recommend_star_active.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../../../../statics/msg_images_id_like.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../../../../statics/msg_images_id_like_hover.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../../../../statics/msg_images_id_like_active.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageItem_container__6xfgf {
    display: flex;
    margin-top: 32px;
}

.MessageItem_avatar__iV8FZ {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.MessageItem_img__ZWGlj {
    width: 51px;
    height: 51px;
    border-radius: 50%;
}

.MessageItem_ai_img__BBQYG {
    width: 51px;
    height: 51px;
    border-radius: 4px;
}

.MessageItem_content__uWw7R {
    display: flex;
    flex-direction: column;
    width: calc(100% - 63px);
    max-width: calc(100% - 63px);
    /* 63px = 51px + 12px */
}

.MessageItem_content_material__73fUm .MessageItem_content_text__q6d2t {
    width: 100%;
}

.MessageItem_content_time__oxeiL {
    margin-top: 4px;
    margin-bottom: 4px;
    font-size: 12px;
    color: #999;
}

.MessageItem_content_text__q6d2t {
    position: relative;
    max-width: 100%;
    display: inline-block;
    position: relative;
}

.MessageItem_content_left__WtDjW {
    margin-right: auto;
    background-color: #74bdc6;
    border-radius: 6px;
}

.MessageItem_content_left__WtDjW .markdown-body {
    color: #fff !important;
    white-space: pre-wrap;
    max-width: 100%;
    padding: 12px;
}

.MessageItem_content_right__srqFv {
    margin-right: auto;
    background-color: #f9f9f9;
    border-radius: 6px;
}

.MessageItem_content_right__srqFv .markdown-body {
    max-width: 100%;
    color: #323A45 !important;
    padding: 12px;
}

.MessageItem_pause_status__7YW7- {
    padding: 12px;
}

.MessageItem_content_recommend__Udj27 {
    margin-bottom: 40px;
}

.MessageItem_content_text_butns__E3J-8 {
    position: absolute;
    width: 150px;
    height: 32px;
    right: -176px;
    top: 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: #fff;
}

.MessageItem_butn__bMV-u {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    margin-right: 5px;
    border-radius: 50%;
    cursor: pointer;
    background-color: #e4f0f2;
}

.MessageItem_butn__bMV-u:hover {
    background-color: #c6e0e4;
}

.MessageItem_butn_img__FJ1cN {
    width: 16px;
    height: 16px;
}

.MessageItem_edit_img__Atqa6 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.MessageItem_butn__bMV-u:hover .MessageItem_edit_img__Atqa6 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.MessageItem_copy_img__WDSaF {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.MessageItem_butn__bMV-u:hover .MessageItem_copy_img__WDSaF {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.MessageItem_like_img__FM9Mc {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.MessageItem_butn__bMV-u:hover .MessageItem_like_img__FM9Mc {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.MessageItem_negative_img__CBLq9 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.MessageItem_butn__bMV-u:hover .MessageItem_negative_img__CBLq9 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.MessageItem_collect_img__FDKZ\\+ {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.MessageItem_butn__bMV-u:hover .MessageItem_collect_img__FDKZ\\+ {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.MessageItem_regenerate_img__p68Dz {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

.MessageItem_butn__bMV-u:hover .MessageItem_regenerate_img__p68Dz {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.MessageItem_butn_active__v7U1Z,
.MessageItem_butn_active__v7U1Z:hover {
    background-color: #17a8b5;
}

.MessageItem_butn_active__v7U1Z .MessageItem_like_img__FM9Mc,
.MessageItem_butn_active__v7U1Z:hover .MessageItem_like_img__FM9Mc {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.MessageItem_butn_active__v7U1Z .MessageItem_negative_img__CBLq9,
.MessageItem_butn_active__v7U1Z:hover .MessageItem_negative_img__CBLq9 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
}

.MessageItem_butn_active__v7U1Z .MessageItem_collect_img__FDKZ\\+,
.MessageItem_butn_active__v7U1Z:hover .MessageItem_collect_img__FDKZ\\+ {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.MessageItem_loading_img__X9gvH {
    width: 48px;
    height: 17px;
}

.MessageItem_recommend_box__sSrts {
    position: absolute;
    right: 0;
    bottom: -40px;
    width: 174px;
    height: 40px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    cursor: pointer;
    background-color: #e4f0f2;
    transition: background-color 0.5s ease-in-out;
}

.MessageItem_recommend_box__sSrts:hover {
    background-image: linear-gradient(to right, #c6e0e4 50%, #e4f0f2 50%);
    background-size: 200% 100%;
    background-position: left bottom;
    transition: background-color 0.5s ease-in-out, background-position 0.5s ease-in-out;
}

.MessageItem_recommend_box__sSrts:not(:hover) {
    background-position: right bottom;
}

.MessageItem_recommend_butn_box__76eKl {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}

.MessageItem_recommend_butn_text__vuXN7 {
    font-size: 14px;
    color: #17a8b5;
    margin-right: 10px;
}

.MessageItem_recommend_butn_icon__IH3lA {
    width: 6px;
    height: 12px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat center / 100% 100%;
    transition: transform 0.5s ease;
}

.MessageItem_recommend_box__sSrts:hover .MessageItem_recommend_butn_icon__IH3lA {
    transform: translateX(5px);
}

.MessageItem_popover_box__7X82z {
    /* padding: 16px; */
}

.MessageItem_popover_item__HxLYT {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 160px;
    height: 40px;
    padding-left: 16px;
    padding-bottom: 3px;
    margin-bottom: 3px;
    cursor: pointer;
    border-radius: 6px;
    transition: background 0.5s;
}

.MessageItem_popover_item__HxLYT:hover {
    background-color: #dfdfdf;
}

.MessageItem_popover_item__HxLYT:active {
    background-color: #cdcdcd;
}

.MessageItem_popover_item_text__yy9Ig {
    font-size: 14px;
    color: #605D64;
}

.custom_popover_message .ant-popover-inner {
    padding: 0;
    border-radius: 6px;
}

.MessageItem_recommend_start__btU9f,
.MessageItem_recommend_start_active__KNDy5 {
    width: 11px;
    height: 10px;
    margin-top: 3px;
    margin-right: 5px;
}

.MessageItem_popover_item_img_box__Z3anB {
    display: flex;
}

.MessageItem_recommend_start__btU9f {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat center / 100% 100%;
}

.MessageItem_recommend_start_active__KNDy5 {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat center / 100% 100%;
}

.msg_images_id_box {
    display: flex;
    justify-content: center;
    margin: 20px 0;
}

.msg_images_id_container {
    width: 200px;
    height: 200px;
    margin-right: 28px;
    /* margin-bottom: 10px; */
    position: relative;
    overflow: hidden;
    cursor: pointer;
}

.msg_images_id_container:last-child {
    margin-right: 0;
}

.msg_images_id_container_num1,
.msg_images_id_container_num2 {
    width: 342px;
    height: 256px;
}

.msg_images_id_container_num3 {
    width: 220px;
    height: 166px;
}

.msg_images_id {
    width: 100%;
    height: 100%;
    transition: transform 0.3s ease-in-out;
    background-color: #f9f9f9 !important;
}

.MessageItem_content_thinking__BRJ9V .msg_images_id_container:hover .msg_images_id {
    transform: none;
}

.msg_images_id_container:hover .msg_images_id {
    transform: scale(1.1);
}

.MessageItem_content_thinking__BRJ9V .msg_images_id_overlay {
    display: none;
}

.msg_images_id_overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.15); /* 灰色半透明 */
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
}

.msg_images_id_container:hover .msg_images_id_overlay {
    opacity: 1;
}

.msg_images_id_overlay .msg_images_id_like {
    position: absolute;
    top: 5px;
    right: 5px;
    width: 32px;
    height: 32px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat center / 100% 100%;
    transition: background 0.5s;
}

/* 隐藏伪元素用来预加载悬停背景图 */
.msg_images_id_overlay .msg_images_id_like::after {
    content: "";
    background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.msg_images_id_overlay .msg_images_id_like:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat center / 100% 100%;
}

.msg_images_id_overlay .msg_images_id_like_active,
.msg_images_id_overlay .msg_images_id_like_active:hover {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat center / 100% 100%;
}

.MessageItem_content_edit__Ps9eB {
    width: 100%;
    padding: 16px;
    background-color: #a2cfd6;
}

.MessageItem_user_edit_box__q9LeS {
    position: relative;
    width: 100%;
    background-color: #a2cfd6;
    padding-bottom: 50px;
}

.MessageItem_custom_textarea__gpJcv {
    font-size: 16px;
    color: #fff;
    background-color: #a2cfd6;
    padding: 0;
}

/* 自定义滚动条 */
.MessageItem_custom_textarea__gpJcv::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.MessageItem_custom_textarea__gpJcv::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.MessageItem_custom_textarea__gpJcv::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.MessageItem_custom_textarea__gpJcv:hover,
.MessageItem_custom_textarea__gpJcv:focus,
.MessageItem_custom_textarea__gpJcv.ant-input-outlined,
.MessageItem_custom_textarea__gpJcv.ant-input-outlined:hover,
.MessageItem_custom_textarea__gpJcv.ant-input-outlined:focus {
    border: none !important;
    background-color: #a2cfd6 !important;
    box-shadow: none !important;
}

.MessageItem_butn_box__SHAWs {
    position: absolute;
    bottom: 0;
    right: 0;
}

.MessageItem_butn_cancel__fuzsP,
.MessageItem_butn_ok__zHq4p {
    width: 75px;
    height: 45px;
    border: 1px solid #17a8b5;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 14px;
    color: #17a8b5;
    background-color: #fff;
    cursor: pointer;
}

.MessageItem_butn_ok__zHq4p {
    background-color: #17a8b5;
    color: #fff;
}
.MessageItem_mobile_container__NMj7R {
    margin-top: 20px;
}
.MessageItem_mobile_container__NMj7R .MessageItem_content__uWw7R {
    width: calc(100% - 42px);
    max-width: calc(100% - 42px);
}
.MessageItem_mobile_container__NMj7R .MessageItem_butn__bMV-u {
    display: none;
}
.MessageItem_mobile_container__NMj7R .MessageItem_img__ZWGlj,.MessageItem_mobile_container__NMj7R .MessageItem_ai_img__BBQYG {
    width: 32px;
    height: 32px;
}
.MessageItem_mobile_container__NMj7R .MessageItem_content_text__q6d2t {
    padding: 6px;
}
.MessageItem_mobile_container__NMj7R .markdown-body {
    font-size: 15px;
}

.MessageItem_reasoning_text__Gw-Dh {
    display: inline-block;
    max-width: 100%;
    padding: 5px 12px 5px;
    margin-bottom: 16px;
    border-left: 1px solid #e5e8eb;
}

/* .reasoning_text p { */
.MessageItem_reasoning_text__Gw-Dh * {
    color: #abafb7;
    font-size: 16px;
}

.MessageItem_loading_container__PoqbP {
    position: relative;
    max-width: 100%;
    display: inline-block;
    position: relative;
    margin-bottom: 12px;
}

.MessageItem_loading_box__bfEE5,
.MessageItem_loading_box_done__gQJhg {
    display: inline-flex;
    align-items: center; /* 垂直居中对齐 */
    padding: 12px;
    background-color: #f9f9f9;
    -webkit-user-select: none;
            user-select: none;
}

.MessageItem_loading_box_done__gQJhg {
    cursor: pointer;
}

.MessageItem_reasoning_butn__budN9,
.MessageItem_reasoning_butn_done__G8LrN,
.MessageItem_reasoning_butn_stop__ktzdb {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    line-height: 27px;
    color: #abafb7;
    background-color: #f9f9f9;
    border-radius: 6px;
}

.MessageItem_reasoning_butn__budN9 {
    margin-left: 16px;
}

.MessageItem_reasoning_butn_done__G8LrN {
    color: #323a45;
}

.MessageItem_reasoning_butn_vector_img__GOKYv {
    margin-left: 16px;
}

.MessageItem_text_query_image_box__N\\+0oy {
    margin-bottom: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/home/components/MessageItem/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,4BAA4B;IAC5B,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,MAAM;IACN,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,yDAAkE;AACtE;;AAEA;IACI,yDAAwE;AAC5E;;AAEA;IACI,yDAAkE;AACtE;;AAEA;IACI,yDAAwE;AAC5E;;AAEA;IACI,yDAAkE;AACtE;;AAEA;IACI,yDAAwE;AAC5E;;AAEA;IACI,yDAAsE;AAC1E;;AAEA;IACI,yDAA4E;AAChF;;AAEA;IACI,yDAAqE;AACzE;;AAEA;IACI,yDAA2E;AAC/E;;AAEA;IACI,0DAAwE;AAC5E;;AAEA;IACI,0DAA8E;AAClF;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI,0DAAyE;AAC7E;;AAEA;;IAEI,0DAA6E;AACjF;;AAEA;;IAEI,0DAA4E;AAChF;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,+BAA+B;IAC/B,eAAe;IACf,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,qEAAqE;IACrE,0BAA0B;IAC1B,gCAAgC;IAChC,mFAAmF;AACvF;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,iFAA2F;IAC3F,+BAA+B;AACnC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iFAAsF;AAC1F;;AAEA;IACI,iFAA6F;AACjG;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,+BAA+B,EAAE,UAAU;IAC3C,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,iFAA0F;IAC1F,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,iFAAgG;IAChG,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iFAAgG;AACpG;;AAEA;;IAEI,iFAAiG;AACrG;;AAEA;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,UAAU;AACd;;AAEA,WAAW;AACX,wDAAqC,UAAU;IAC3C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,8DAA2C,WAAW;IAClD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;;IAKI,uBAAuB;IACvB,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;AACZ;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;AACA;IACI,wBAAwB;IACxB,4BAA4B;AAChC;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA,wBAAwB;AACxB;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB,EAAE,WAAW;IAChC,aAAa;IACb,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;IAGI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".container {\n    display: flex;\n    margin-top: 32px;\n}\n\n.avatar {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.img {\n    width: 51px;\n    height: 51px;\n    border-radius: 50%;\n}\n\n.ai_img {\n    width: 51px;\n    height: 51px;\n    border-radius: 4px;\n}\n\n.content {\n    display: flex;\n    flex-direction: column;\n    width: calc(100% - 63px);\n    max-width: calc(100% - 63px);\n    /* 63px = 51px + 12px */\n}\n\n.content_material .content_text {\n    width: 100%;\n}\n\n.content_time {\n    margin-top: 4px;\n    margin-bottom: 4px;\n    font-size: 12px;\n    color: #999;\n}\n\n.content_text {\n    position: relative;\n    max-width: 100%;\n    display: inline-block;\n    position: relative;\n}\n\n.content_left {\n    margin-right: auto;\n    background-color: #74bdc6;\n    border-radius: 6px;\n}\n\n.content_left :global(.markdown-body) {\n    color: #fff !important;\n    white-space: pre-wrap;\n    max-width: 100%;\n    padding: 12px;\n}\n\n.content_right {\n    margin-right: auto;\n    background-color: #f9f9f9;\n    border-radius: 6px;\n}\n\n.content_right :global(.markdown-body) {\n    max-width: 100%;\n    color: #323A45 !important;\n    padding: 12px;\n}\n\n.pause_status {\n    padding: 12px;\n}\n\n.content_recommend {\n    margin-bottom: 40px;\n}\n\n.content_text_butns {\n    position: absolute;\n    width: 150px;\n    height: 32px;\n    right: -176px;\n    top: 0;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    background-color: #fff;\n}\n\n.butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 32px;\n    height: 32px;\n    margin-right: 5px;\n    border-radius: 50%;\n    cursor: pointer;\n    background-color: #e4f0f2;\n}\n\n.butn:hover {\n    background-color: #c6e0e4;\n}\n\n.butn_img {\n    width: 16px;\n    height: 16px;\n}\n\n.edit_img {\n    background-image: url('../../../../statics/content_text_edit.png');\n}\n\n.butn:hover .edit_img {\n    background-image: url('../../../../statics/content_text_edit_hover.png');\n}\n\n.copy_img {\n    background-image: url('../../../../statics/content_text_copy.png');\n}\n\n.butn:hover .copy_img {\n    background-image: url('../../../../statics/content_text_copy_hover.png');\n}\n\n.like_img {\n    background-image: url('../../../../statics/content_text_like.png');\n}\n\n.butn:hover .like_img {\n    background-image: url('../../../../statics/content_text_like_hover.png');\n}\n\n.negative_img {\n    background-image: url('../../../../statics/content_text_negative.png');\n}\n\n.butn:hover .negative_img {\n    background-image: url('../../../../statics/content_text_negative_hover.png');\n}\n\n.collect_img {\n    background-image: url('../../../../statics/content_text_collect.png');\n}\n\n.butn:hover .collect_img {\n    background-image: url('../../../../statics/content_text_collect_hover.png');\n}\n\n.regenerate_img {\n    background-image: url('../../../../statics/content_text_regenerate.png');\n}\n\n.butn:hover .regenerate_img {\n    background-image: url('../../../../statics/content_text_regenerate_hover.png');\n}\n\n.butn_active,\n.butn_active:hover {\n    background-color: #17a8b5;\n}\n\n.butn_active .like_img,\n.butn_active:hover .like_img {\n    background-image: url('../../../../statics/content_text_like_active.png');\n}\n\n.butn_active .negative_img,\n.butn_active:hover .negative_img {\n    background-image: url('../../../../statics/content_text_negative_active.png');\n}\n\n.butn_active .collect_img,\n.butn_active:hover .collect_img {\n    background-image: url('../../../../statics/content_text_collect_active.png');\n}\n\n.loading_img {\n    width: 48px;\n    height: 17px;\n}\n\n.recommend_box {\n    position: absolute;\n    right: 0;\n    bottom: -40px;\n    width: 174px;\n    height: 40px;\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n    cursor: pointer;\n    background-color: #e4f0f2;\n    transition: background-color 0.5s ease-in-out;\n}\n\n.recommend_box:hover {\n    background-image: linear-gradient(to right, #c6e0e4 50%, #e4f0f2 50%);\n    background-size: 200% 100%;\n    background-position: left bottom;\n    transition: background-color 0.5s ease-in-out, background-position 0.5s ease-in-out;\n}\n\n.recommend_box:not(:hover) {\n    background-position: right bottom;\n}\n\n.recommend_butn_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n}\n\n.recommend_butn_text {\n    font-size: 14px;\n    color: #17a8b5;\n    margin-right: 10px;\n}\n\n.recommend_butn_icon {\n    width: 6px;\n    height: 12px;\n    background: url('../../../../statics/recommend_butn_icon.png') no-repeat center / 100% 100%;\n    transition: transform 0.5s ease;\n}\n\n.recommend_box:hover .recommend_butn_icon {\n    transform: translateX(5px);\n}\n\n.popover_box {\n    /* padding: 16px; */\n}\n\n.popover_item {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 160px;\n    height: 40px;\n    padding-left: 16px;\n    padding-bottom: 3px;\n    margin-bottom: 3px;\n    cursor: pointer;\n    border-radius: 6px;\n    transition: background 0.5s;\n}\n\n.popover_item:hover {\n    background-color: #dfdfdf;\n}\n\n.popover_item:active {\n    background-color: #cdcdcd;\n}\n\n.popover_item_text {\n    font-size: 14px;\n    color: #605D64;\n}\n\n:global(.custom_popover_message .ant-popover-inner) {\n    padding: 0;\n    border-radius: 6px;\n}\n\n.recommend_start,\n.recommend_start_active {\n    width: 11px;\n    height: 10px;\n    margin-top: 3px;\n    margin-right: 5px;\n}\n\n.popover_item_img_box {\n    display: flex;\n}\n\n.recommend_start {\n    background: url('../../../../statics/recommend_star.png') no-repeat center / 100% 100%;\n}\n\n.recommend_start_active {\n    background: url('../../../../statics/recommend_star_active.png') no-repeat center / 100% 100%;\n}\n\n:global(.msg_images_id_box) {\n    display: flex;\n    justify-content: center;\n    margin: 20px 0;\n}\n\n:global(.msg_images_id_container) {\n    width: 200px;\n    height: 200px;\n    margin-right: 28px;\n    /* margin-bottom: 10px; */\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n}\n\n:global(.msg_images_id_container:last-child) {\n    margin-right: 0;\n}\n\n:global(.msg_images_id_container_num1),\n:global(.msg_images_id_container_num2) {\n    width: 342px;\n    height: 256px;\n}\n\n:global(.msg_images_id_container_num3) {\n    width: 220px;\n    height: 166px;\n}\n\n:global(.msg_images_id) {\n    width: 100%;\n    height: 100%;\n    transition: transform 0.3s ease-in-out;\n    background-color: #f9f9f9 !important;\n}\n\n.content_thinking :global(.msg_images_id_container:hover .msg_images_id) {\n    transform: none;\n}\n\n:global(.msg_images_id_container:hover .msg_images_id) {\n    transform: scale(1.1);\n}\n\n.content_thinking :global(.msg_images_id_overlay) {\n    display: none;\n}\n\n:global(.msg_images_id_overlay) {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.15); /* 灰色半透明 */\n    opacity: 0;\n    transition: opacity 0.3s ease-in-out;\n}\n\n:global(.msg_images_id_container:hover .msg_images_id_overlay) {\n    opacity: 1;\n}\n\n:global(.msg_images_id_overlay .msg_images_id_like) {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    width: 32px;\n    height: 32px;\n    background: url('../../../../statics/msg_images_id_like.png') no-repeat center / 100% 100%;\n    transition: background 0.5s;\n}\n\n/* 隐藏伪元素用来预加载悬停背景图 */\n:global(.msg_images_id_overlay .msg_images_id_like::after) {\n    content: \"\";\n    background: url('../../../../statics/msg_images_id_like_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n:global(.msg_images_id_overlay .msg_images_id_like:hover) {\n    background: url('../../../../statics/msg_images_id_like_hover.png') no-repeat center / 100% 100%;\n}\n\n:global(.msg_images_id_overlay .msg_images_id_like_active),\n:global(.msg_images_id_overlay .msg_images_id_like_active:hover) {\n    background: url('../../../../statics/msg_images_id_like_active.png') no-repeat center / 100% 100%;\n}\n\n.content_edit {\n    width: 100%;\n    padding: 16px;\n    background-color: #a2cfd6;\n}\n\n.user_edit_box {\n    position: relative;\n    width: 100%;\n    background-color: #a2cfd6;\n    padding-bottom: 50px;\n}\n\n.custom_textarea {\n    font-size: 16px;\n    color: #fff;\n    background-color: #a2cfd6;\n    padding: 0;\n}\n\n/* 自定义滚动条 */\n.custom_textarea::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.custom_textarea::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.custom_textarea::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.custom_textarea:hover,\n.custom_textarea:focus,\n.custom_textarea:global(.ant-input-outlined),\n.custom_textarea:global(.ant-input-outlined:hover),\n.custom_textarea:global(.ant-input-outlined:focus) {\n    border: none !important;\n    background-color: #a2cfd6 !important;\n    box-shadow: none !important;\n}\n\n.butn_box {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n}\n\n.butn_cancel,\n.butn_ok {\n    width: 75px;\n    height: 45px;\n    border: 1px solid #17a8b5;\n    border-radius: 6px;\n    margin-right: 7px;\n    font-size: 14px;\n    color: #17a8b5;\n    background-color: #fff;\n    cursor: pointer;\n}\n\n.butn_ok {\n    background-color: #17a8b5;\n    color: #fff;\n}\n.mobile_container {\n    margin-top: 20px;\n}\n.mobile_container .content {\n    width: calc(100% - 42px);\n    max-width: calc(100% - 42px);\n}\n.mobile_container .butn {\n    display: none;\n}\n.mobile_container .img,.mobile_container .ai_img {\n    width: 32px;\n    height: 32px;\n}\n.mobile_container .content_text {\n    padding: 6px;\n}\n.mobile_container :global(.markdown-body) {\n    font-size: 15px;\n}\n\n.reasoning_text {\n    display: inline-block;\n    max-width: 100%;\n    padding: 5px 12px 5px;\n    margin-bottom: 16px;\n    border-left: 1px solid #e5e8eb;\n}\n\n/* .reasoning_text p { */\n.reasoning_text * {\n    color: #abafb7;\n    font-size: 16px;\n}\n\n.loading_container {\n    position: relative;\n    max-width: 100%;\n    display: inline-block;\n    position: relative;\n    margin-bottom: 12px;\n}\n\n.loading_box,\n.loading_box_done {\n    display: inline-flex;\n    align-items: center; /* 垂直居中对齐 */\n    padding: 12px;\n    background-color: #f9f9f9;\n    user-select: none;\n}\n\n.loading_box_done {\n    cursor: pointer;\n}\n\n.reasoning_butn,\n.reasoning_butn_done,\n.reasoning_butn_stop {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n    line-height: 27px;\n    color: #abafb7;\n    background-color: #f9f9f9;\n    border-radius: 6px;\n}\n\n.reasoning_butn {\n    margin-left: 16px;\n}\n\n.reasoning_butn_done {\n    color: #323a45;\n}\n\n.reasoning_butn_vector_img {\n    margin-left: 16px;\n}\n\n.text_query_image_box {\n    margin-bottom: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MessageItem_container__6xfgf`,
	"avatar": `MessageItem_avatar__iV8FZ`,
	"img": `MessageItem_img__ZWGlj`,
	"ai_img": `MessageItem_ai_img__BBQYG`,
	"content": `MessageItem_content__uWw7R`,
	"content_material": `MessageItem_content_material__73fUm`,
	"content_text": `MessageItem_content_text__q6d2t`,
	"content_time": `MessageItem_content_time__oxeiL`,
	"content_left": `MessageItem_content_left__WtDjW`,
	"content_right": `MessageItem_content_right__srqFv`,
	"pause_status": `MessageItem_pause_status__7YW7-`,
	"content_recommend": `MessageItem_content_recommend__Udj27`,
	"content_text_butns": `MessageItem_content_text_butns__E3J-8`,
	"butn": `MessageItem_butn__bMV-u`,
	"butn_img": `MessageItem_butn_img__FJ1cN`,
	"edit_img": `MessageItem_edit_img__Atqa6`,
	"copy_img": `MessageItem_copy_img__WDSaF`,
	"like_img": `MessageItem_like_img__FM9Mc`,
	"negative_img": `MessageItem_negative_img__CBLq9`,
	"collect_img": `MessageItem_collect_img__FDKZ+`,
	"regenerate_img": `MessageItem_regenerate_img__p68Dz`,
	"butn_active": `MessageItem_butn_active__v7U1Z`,
	"loading_img": `MessageItem_loading_img__X9gvH`,
	"recommend_box": `MessageItem_recommend_box__sSrts`,
	"recommend_butn_box": `MessageItem_recommend_butn_box__76eKl`,
	"recommend_butn_text": `MessageItem_recommend_butn_text__vuXN7`,
	"recommend_butn_icon": `MessageItem_recommend_butn_icon__IH3lA`,
	"popover_box": `MessageItem_popover_box__7X82z`,
	"popover_item": `MessageItem_popover_item__HxLYT`,
	"popover_item_text": `MessageItem_popover_item_text__yy9Ig`,
	"recommend_start": `MessageItem_recommend_start__btU9f`,
	"recommend_start_active": `MessageItem_recommend_start_active__KNDy5`,
	"popover_item_img_box": `MessageItem_popover_item_img_box__Z3anB`,
	"content_thinking": `MessageItem_content_thinking__BRJ9V`,
	"content_edit": `MessageItem_content_edit__Ps9eB`,
	"user_edit_box": `MessageItem_user_edit_box__q9LeS`,
	"custom_textarea": `MessageItem_custom_textarea__gpJcv`,
	"butn_box": `MessageItem_butn_box__SHAWs`,
	"butn_cancel": `MessageItem_butn_cancel__fuzsP`,
	"butn_ok": `MessageItem_butn_ok__zHq4p`,
	"mobile_container": `MessageItem_mobile_container__NMj7R`,
	"reasoning_text": `MessageItem_reasoning_text__Gw-Dh`,
	"loading_container": `MessageItem_loading_container__PoqbP`,
	"loading_box": `MessageItem_loading_box__bfEE5`,
	"loading_box_done": `MessageItem_loading_box_done__gQJhg`,
	"reasoning_butn": `MessageItem_reasoning_butn__budN9`,
	"reasoning_butn_done": `MessageItem_reasoning_butn_done__G8LrN`,
	"reasoning_butn_stop": `MessageItem_reasoning_butn_stop__ktzdb`,
	"reasoning_butn_vector_img": `MessageItem_reasoning_butn_vector_img__GOKYv`,
	"text_query_image_box": `MessageItem_text_query_image_box__N+0oy`
};
export default ___CSS_LOADER_EXPORT___;
